import config from '../../config';

export const getSendbirdAppId = () => {
  return config.sendbird.appId;
};

export const QUERY_LIMIT = 50;
